import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { resetAll } from 'reducers';
import { AppointmentCancellationResponse, getRequestedCancellationAppointments } from 'services';

export type State = ApiState<AppointmentCancellationResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchRequestedCancellationAppts = createAsyncThunk(
  'get/requestedCancellationAppts',
  async (rowsPerPage: number) => await getRequestedCancellationAppointments(rowsPerPage)
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const requestedCancellationApptsSlice = createSlice({
  name: 'requestedCancellationAppts',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {
    unmountRequestedCancellationAppts: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRequestedCancellationAppts.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      fetchRequestedCancellationAppts.fulfilled,
      (state, action: PayloadAction<AppointmentCancellationResponse>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.hasLoaded = true;
      }
    );

    builder.addCase(fetchRequestedCancellationAppts.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });

    builder.addCase(resetAll, () => initialState);
  },
});

export const stateSelector_ = (state: { requestedCancellationAppts: State }): State => state.requestedCancellationAppts;

export const requestedCancellationAppts_ = createSelector(stateSelector_, (state) => state.data);

export const requestedCancellationApptsIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const requestedCancellationApptsHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export const { unmountRequestedCancellationAppts } = requestedCancellationApptsSlice.actions;

export default requestedCancellationApptsSlice.reducer;
